/* ========================================================
   7T＋ ティージェラート LP
   - ヒーロー：画面内に入ったら行ごとに出現アニメーション
   - フレーバーカードの説明文 開閉（アコーディオン・高さアニメーション）
   ======================================================== */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    /* ---- ヒーロー：各行がスクロールで画面内に入ったら順次出現 ---- */
    var STAGGER = 0.2; // 同時に入った行同士の間隔（秒）
    var heroLineEls = document.querySelectorAll('.hero-line');
    if (heroLineEls.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            // 同じタイミングで入った行（初期表示など）は上から順にstaggerを付与
            var appearing = entries
              .filter(function (e) {
                return e.isIntersecting;
              })
              .sort(function (a, b) {
                return a.boundingClientRect.top - b.boundingClientRect.top;
              });
            appearing.forEach(function (e, i) {
              var el = e.target;
              el.style.animationDelay =
                (appearing.length > 1 ? i * STAGGER : 0) + 's';
              el.classList.add('is-visible');
              io.unobserve(el);
            });
          },
          { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
        );
        heroLineEls.forEach(function (el) {
          io.observe(el);
        });
      } else {
        // 非対応環境ではそのまま表示
        heroLineEls.forEach(function (el) {
          el.classList.add('is-visible');
        });
      }
    }

    /* ---- フレーバーカードの開閉 ---- */
    var cards = document.querySelectorAll('.flavor-card');

    cards.forEach(function (card) {
      var toggle = card.querySelector('.flavor-toggle');
      var label = toggle ? toggle.querySelector('.visually-hidden') : null;
      var desc = card.querySelector('.flavor-desc');
      if (!toggle) return;

      function openDesc() {
        // 0 → 実際の高さ へアニメーション後、auto に戻す（リサイズ追従のため）
        desc.style.height = desc.scrollHeight + 'px';
        desc.addEventListener('transitionend', function onEnd(e) {
          if (e.propertyName !== 'height') return;
          if (card.classList.contains('is-open')) desc.style.height = 'auto';
          desc.removeEventListener('transitionend', onEnd);
        });
      }

      function closeDesc() {
        // auto → 現在の高さ(px) に固定してから 0 へ（0へのトランジションを効かせる）
        desc.style.height = desc.scrollHeight + 'px';
        void desc.offsetHeight; // 強制リフロー
        desc.style.height = '0';
      }

      toggle.addEventListener('click', function () {
        var isOpen = card.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(isOpen));
        if (label) label.textContent = isOpen ? '説明を閉じる' : '説明を見る';
        if (!desc) return;
        if (isOpen) openDesc();
        else closeDesc();
      });
    });
  });
})();
